<ion-header>
    <ion-toolbar>
        <ion-title>{{title}}</ion-title>
        <ion-buttons slot="end">
            <ion-button uppDataid="address-submit-button" [hidden]="AddressForm.pristine || AddressForm.invalid || !_mapinfo.validated" (click)="AcceptModal()">
                <ion-icon slot="icon-only" name="checkmark"></ion-icon>
            </ion-button>        
            <ion-button uppDataid="address-close-button" (click)="CloseModal()">
                <ion-icon slot="icon-only" name="close"></ion-icon>
            </ion-button>        
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content>
    <div class="mapcontainer">
        <div *ngIf="(gmapsApiLoaded | async) === true" style="height: 100%; width: 100%;">
            <google-map #googlemap  uppDataid="address-google-map" id="googlemap" [mapId]="GoogleMapId" height="100%" width="100%" [options]="{ mapTypeControl: false, fullscreenControl: false }" [zoom]="_mapinfo.zoom" [center]="_mapinfo.position" (mapClick)="onMapClick($event)">
                <map-advanced-marker uppDataid="address-google-marker" *ngFor="let marker of _mapinfo.markers" [position]="marker.position"></map-advanced-marker>
            </google-map>    
        </div>
    </div>
    <form class="address-form" [formGroup]="AddressForm">
        <ion-item>
            <upp-input uppDataid="address-street-text" 
                formControlName="address" 
                type='text' 
                placeholder="{{tr('@address_enter_street')}}"
                (Changed)="onFormChanged()"
                [errornfo]="{ required: tr('@mandatory_field') }"
            ></upp-input>
        </ion-item>
        <ion-item>
            <upp-input uppDataid="address-number-text" 
                style="min-width: 30%" 
                formControlName="number" 
                type='text' 
                placeholder="{{tr('@address_enter_number')}}"
                (Changed)="onFormChanged()"
            ></upp-input>
            <upp-input uppDataid="address-door-text" 
                style="margin-left: 8px"
                formControlName="door" 
                type='text' 
                placeholder="{{tr('@address_enter_door')}}"
            ></upp-input>
        </ion-item>
        <ion-item>
            <upp-input uppDataid="address-locality-text" 
                formControlName="locality" 
                type='text' 
                placeholder="{{tr('@address_enter_locality')}}"
                (Changed)="onFormChanged()"
                [errornfo]="{ required: tr('@mandatory_field') }"
            ></upp-input>
        </ion-item>
        <ion-toolbar>
            <ion-buttons slot="start">
                <ion-button uppDataid="address-locate-button" 
                    color="primary" 
                    expand="block" 
                    fill="solid"
                    shape="round"
                    (click)="onLocate()"
                >
                    <ion-icon slot="start" name="locate"></ion-icon>
                    {{tr('@address_go_to_current')}}
                </ion-button>
            </ion-buttons>
            <ion-buttons slot="end">
                <ion-button uppDataid="address-validate-button" 
                    [ngClass]="{ 'hidden': _mapinfo.validated !== false }"
                    color="danger" 
                    expand="block" 
                    fill="solid"
                    shape="round"
                    [disabled]="!AddressForm.valid"
                    (click)="onValidate()"
                >
                    <ion-icon slot="start" name="checkmark-circle-outline"></ion-icon>
                    {{tr('@address_validate')}}
                </ion-button>
                <ion-button uppDataid="address-msgvalid-info" 
                    [ngClass]="{ 'hidden': _mapinfo.validated === false }"
                    color="success" 
                    fill="solid"
                    shape="round"
                    expand="block" 
                    (click)="AcceptModal()"
                >
                    <ion-icon slot="start" name="checkmark-circle-outline"></ion-icon>
                    {{tr('@address_msgvalid')}}
                </ion-button>
            </ion-buttons>
        </ion-toolbar>
    </form>
</ion-content>